import { render, staticRenderFns } from "./campaign_edit.vue?vue&type=template&id=d5ff0c88&"
import script from "./campaign_edit.vue?vue&type=script&lang=js&"
export * from "./campaign_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports